import Tabs from "@/components/Tabs";
import AppLayout from "@/layouts/AppLayout";
import { useNavigate } from "@/router";
import type { Path } from "@/router";
import { useLocation } from "react-router-dom";

function ActivitiesTabs() {
  const location = useLocation();
  const { pathname } = location;
  const navigate = useNavigate();

  const items = [
    {
      label: "Events",
      to: "/activities/events" as const
    },
    {
      label: "PDR Activity Types",
      to: "/activities/activity-types" as const
    }
  ];

  return (
    <Tabs
      tabItems={items.map(({ label, to }) => ({
        label,
        onClick: () => navigate(to as Path),
        active: (pathname.endsWith("/") ? pathname.slice(0, -1) : pathname) === to
      }))}
    />
  );
}

export default function TabLayout({ children }: { children: React.ReactNode }) {
  return (
    <AppLayout>
      <ActivitiesTabs />
      <div className="flex flex-col">{children}</div>
    </AppLayout>
  );
}
